module.exports = __webpack_public_path__ + "img/yecpin_banner.fbc71d2d.jpeg";